module.exports = __webpack_public_path__ + "static/media/do.704fd2a9.svg";